var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 160,
    viewBox: "0 0 640 160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 320.5 87)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -212.55 -553.13)",
    id: "batiment_constructible"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,238,217)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -456.5,
    rx: 0,
    ry: 0,
    width: 159,
    height: 913
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -185.21 -30.34)",
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.75,
    y: -31.75,
    rx: 0,
    ry: 0,
    width: 63.5,
    height: 63.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -185.55 -50.93)",
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.5,
    y: -2.5,
    rx: 0,
    ry: 0,
    width: 63,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -182.85 -30)",
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -32,
    rx: 0,
    ry: 0,
    width: 5,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -212.55 61.8)",
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -9,
    rx: 0,
    ry: 0,
    width: 159,
    height: 18
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -185.55 20.62)",
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(202,119,4)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(202,119,4)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -32.5,
    y: -5.5,
    rx: 0,
    ry: 0,
    width: 65,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -212.21 -73.88)",
    id: "batiment_constructible"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -212.21 73.27)",
    id: "batiment_constructible"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 -185.21 30.07)",
    id: "ombres"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -33.25,
    y1: 0,
    x2: 33.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 2.1 -553.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,238,217)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -456.5,
    rx: 0,
    ry: 0,
    width: 159,
    height: 913
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 29.44 -30.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.75,
    y: -31.75,
    rx: 0,
    ry: 0,
    width: 63.5,
    height: 63.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 29.1 -50.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.5,
    y: -2.5,
    rx: 0,
    ry: 0,
    width: 63,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 31.8 -30)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -32,
    rx: 0,
    ry: 0,
    width: 5,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 2.1 61.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -9,
    rx: 0,
    ry: 0,
    width: 159,
    height: 18
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 29.1 20.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(202,119,4)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(202,119,4)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -32.5,
    y: -5.5,
    rx: 0,
    ry: 0,
    width: 65,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 2.44 -73.88)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 2.44 73.27)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 29.44 30.07)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -33.25,
    y1: 0,
    x2: 33.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 214.05 -553.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,238,217)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -456.5,
    rx: 0,
    ry: 0,
    width: 159,
    height: 913
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 241.39 -30.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(10,11,15)",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(231,232,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.75,
    y: -31.75,
    rx: 0,
    ry: 0,
    width: 63.5,
    height: 63.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 241.05 -50.93)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -31.5,
    y: -2.5,
    rx: 0,
    ry: 0,
    width: 63,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 243.75 -30)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(20,21,30)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.5,
    y: -32,
    rx: 0,
    ry: 0,
    width: 5,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 214.05 61.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -79.5,
    y: -9,
    rx: 0,
    ry: 0,
    width: 159,
    height: 18
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 241.05 20.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(202,119,4)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(202,119,4)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -32.5,
    y: -5.5,
    rx: 0,
    ry: 0,
    width: 65,
    height: 11
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 214.39 -73.88)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 214.39 73.27)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -79.25,
    y1: 0,
    x2: 79.25,
    y2: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.35 0 0 1.35 241.39 30.07)"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(48,74,84)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(48,74,84)",
      fillRule: "nonzero",
      opacity: 0.38
    },
    x1: -33.25,
    y1: 0,
    x2: 33.25,
    y2: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.b9c2da0ee91a9491a890f1e79a358111.svg";
export { ForwardRef as ReactComponent };